module.exports = __webpack_public_path__ + "static/media/5.93e0e5e1.JPG";